import { render, staticRenderFns } from "./input-button-choice.vue?vue&type=template&id=edf6d0ac&"
import script from "./input-button-choice.vue?vue&type=script&lang=js&"
export * from "./input-button-choice.vue?vue&type=script&lang=js&"
import style0 from "./input-button-choice.vue?vue&type=style&index=0&id=edf6d0ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports